import { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SearchIcon from "@material-ui/icons/Search";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { DeleteOutlined } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";

import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import useClienteController from "../controllers/ClienteController";
import TableDefault from "../../../../components/grid/TableDefault";
import {
  HeaderAccordion,
  TableContent,
  HeaderCard,
  IconButtonStyled,
} from "../styles/Cliente";
import ModalClienteEndereco from "./ModalClienteEndereco";
import MaskService from "../../../../utils/mask/maskService";
import { ClienteContext } from "../contexts/ClienteContext";
import { Margin } from "../../../../theme/styles/Utils";
import Chip from "../../../../components/basics/Chip";
import Card from "../../../../components/cards/Card";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";

export default function AccordionClienteEndereco() {
  const {
    billingCep,
    billingComplement,
    billingNewAddress,
    setBillingNewAddress,
    billingNumber,
    setBillingNumber,
    setBillingComplement,
    billingCounty,
    setBillingCounty,
    billingUf,
    setBillingUf,
    billingDistrict,
    setBillingDistrict,
    deliveryAddress,
    setDeliveryAddress,

    loadingInputs,
    listUf,
    listCounty,
    expanded,
    errors,
  } = useContext(ClienteContext);
  const {
    handleChangeOpenAcordion,
    handleEditItemTable,
    handleRemoveItemTable,
    handleChangeCep,
    handleChangeUf,
  } = useClienteController();
  const [open, setOpen] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);
  const [dataTable, setDataTable] = useState([]);

  const columns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
    },
    {
      id: "padrao",
      label: "Padrão",
    },
    {
      id: "endereco",
      label: "Endereço",
    },
  ];

  useEffect(() => {
    (async () => {
      const newList = [];
      deliveryAddress.forEach(
        (item, index) =>
          (newList[index] = {
            ...item,
            telefone: MaskService.toMask("cel-phone", item.telefone || ""),
            cep: MaskService.toMask("cep", item.cep || ""),
            acoes: (
              <SpeedDialErp
                actions={[
                  {
                    icon: <EditOutlinedIcon />,
                    name: "Editar",
                    action: () =>
                      handleEditItemTable(setOpen, setRowEdit, item, index),
                  },
                  {
                    icon: <DeleteOutlined />,
                    name: "Excluir",
                    action: () =>
                      handleRemoveItemTable(
                        setDeliveryAddress,
                        setDataTable,
                        deliveryAddress,
                        index
                      ),
                  },
                ]}
              />
            ),
          })
      );

      setDataTable(newList);
    })();
  }, [
    deliveryAddress,
    handleEditItemTable,
    handleRemoveItemTable,
    setDeliveryAddress,
  ]);

  return (
    <>
      {open && (
        <ModalClienteEndereco
          open={open}
          setOpen={setOpen}
          rowEdit={rowEdit}
          setRowEdit={setRowEdit}
          setDeliveryAddress={setDeliveryAddress}
          deliveryAddress={deliveryAddress}
        />
      )}
      <Grid item xs={12}>
        <Accordion
          expanded={expanded.address || false}
          onChange={() => handleChangeOpenAcordion("address")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container>
                <Grid item xs={12}>
                  <Chip
                    label="ENDEREÇOS COBRANÇA/ENTREGA"
                    bgcolor={
                      !expanded.address &&
                      errors.accordions &&
                      errors.accordions.includes("address")
                        ? "red"
                        : "default"
                    }
                    textcolor={
                      !expanded.address &&
                      errors.accordions &&
                      errors.accordions.includes("address")
                        ? "white"
                        : "default"
                    }
                  />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <Card
                  line="left"
                  lineColor="primary"
                  ti
                  titulo="Endereço de Cobrança"
                >
                  <HeaderCard>
                    <Grid container>
                      <Chip label="COBRANÇA" bgcolor="secondary" />
                    </Grid>
                  </HeaderCard>

                  <Grid container xs={12} spacing={2}>
                    <Grid item lg={12} md={12} sm={6} xs={12}>
                      <TextFieldErp
                        error={errors.billingCep || false}
                        helperText={errors.billingCep || ""}
                        label="CEP"
                        value={billingCep}
                        onChange={(value) => handleChangeCep(value, "billing")}
                        mask="cep"
                        InputProps={{
                          endAdornment: <SearchIcon onClick={() => {}} />,
                        }}
                      />
                    </Grid>

                    <Grid item lg={10} md={12} sm={6} xs={12}>
                      <TextFieldErp
                        label="Endereço"
                        maxLength={120}
                        value={billingNewAddress}
                        setValue={setBillingNewAddress}
                      />
                    </Grid>

                    <Grid item lg={2} md={2} sm={6} xs={12}>
                      <TextFieldErp
                        label="Número"
                        maxLength={10}
                        value={billingNumber}
                        setValue={setBillingNumber}
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <SelectErp
                        loading={loadingInputs.listUf || false}
                        label="Estado"
                        value={billingUf || null}
                        onChange={(e) =>
                          handleChangeUf(e, setBillingUf, setBillingCounty)
                        }
                        optionsList={listUf}
                        descriptionField="estado"
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <SelectErp
                        loading={loadingInputs.listCounty || false}
                        label="Municipio"
                        value={billingCounty}
                        setValue={setBillingCounty}
                        optionsList={
                          billingUf
                            ? listCounty.filter(
                                (opt) => opt.estado_codigo === billingUf.codibge
                              )
                            : []
                        }
                        descriptionField="municipio"
                      />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextFieldErp
                        label="Bairro"
                        maxLength={60}
                        value={billingDistrict}
                        setValue={setBillingDistrict}
                      />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextFieldErp
                        label="Complemento"
                        maxLength={50}
                        value={billingComplement}
                        setValue={setBillingComplement}
                      />
                      <Margin bottom="13" />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item md={6} xs={12}>
                <Card line="left" fullHeight lineColor="primary">
                  <HeaderCard>
                    <Grid container spacing={2}>
                      <Grid item xs={9}>
                        <Chip label="ENTREGA" bgcolor="secondary" />
                      </Grid>

                      <Grid item flex={1}>
                        <Tooltip title="Adicionar Entrega">
                          <IconButtonStyled onClick={() => setOpen(true)}>
                            <AddIcon />
                          </IconButtonStyled>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </HeaderCard>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableContent>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <TableDefault
                              columns={columns}
                              values={dataTable}
                              tableTitle=""
                              rowsPerPage={3}
                              maxHeight="33vh"
                              stickyHeader
                            />
                          </Grid>
                        </Grid>
                      </TableContent>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
